<template>
  <div class="mall-my-list">
    <header class="mall-my-list__head">
      <h1>구매후기</h1>
      <p>내가 작성한 상품 구매후기를 확인합니다.</p>
    </header>

    <div v-if="loading" class="mall-my-list__empty">불러오는 중입니다…</div>

    <div v-else-if="errorMessage" class="mall-my-list__empty">
      <AppIcon icon="mdi-alert-outline" :size="48" />
      <p>{{ errorMessage }}</p>
      <button type="button" class="mall-my-list__action-btn" @click="loadReviews">다시 시도</button>
    </div>

    <div v-else-if="!reviews.length" class="mall-my-list__empty">
      <AppIcon icon="mdi-message-text-outline" :size="48" />
      <p>작성한 구매후기가 없습니다.</p>
      <em>배송완료·구매확정 후 상품상세에서 구매후기를 남길 수 있습니다.</em>
      <router-link :to="MALL_ORDERS_PATH">주문내역 보기</router-link>
    </div>

    <ul v-else class="mall-my-list__cards">
      <li v-for="review in reviews" :key="review.idx">
        <div class="mall-my-list__meta">
          <strong>★ {{ review.rating }}</strong>
          <time>{{ review.date }}</time>
        </div>
        <router-link
          :to="mallProductPath(review.productCode)"
          class="mall-my-list__product"
        >
          <img
            v-if="review.productImage"
            :src="review.productImage"
            :alt="review.productName"
          />
          <span>{{ review.productName }}</span>
        </router-link>
        <p v-if="review.orderCode" class="mall-my-list__order">
          <router-link :to="`/mall/orders/${encodeURIComponent(review.orderCode)}`">
            관련 주문 {{ review.orderCode }}
          </router-link>
          <em v-if="review.orderAt"> · {{ String(review.orderAt).slice(0, 10) }}</em>
        </p>
        <p class="mall-my-list__title">{{ review.content }}</p>
        <a
          v-if="review.image"
          :href="review.image"
          class="mall-my-list__photo"
          target="_blank"
          rel="noopener"
        >
          <img :src="review.image" alt="구매후기 사진" />
        </a>
        <p v-if="review.reply" class="mall-my-list__reply">
          <b>판매자 답변</b>
          {{ review.reply }}
        </p>
        <div class="mall-my-list__actions">
          <router-link :to="`${mallProductPath(review.productCode)}?tab=review`">
            상품에서 보기
          </router-link>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import { fetchMyReviews, type SellerMallReview } from '@/api/mallReview'
import { mallProductPath, MALL_ORDERS_PATH } from '@/constants/mall'

const loading = ref(true)
const errorMessage = ref('')
const reviews = ref<SellerMallReview[]>([])

async function loadReviews() {
  loading.value = true
  errorMessage.value = ''
  try {
    reviews.value = await fetchMyReviews()
  } catch (error) {
    reviews.value = []
    errorMessage.value = error instanceof Error ? error.message : '구매후기를 불러오지 못했습니다.'
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  void loadReviews()
})
</script>

<style lang="scss" src="./MallMyListPage.scss"></style>
